import React, { useState, useEffect } from "react";
import DatePicker from "react-mobile-datepicker-jalaali-persian";
import * as jalaali from "jalaali-js";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";

const Personalinfo = (props) => {
  const [time, setTime] = useState(
    jalaali.toJalaali(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDay()
    )
  );
  const [isOpen, setIsOpen] = useState(false);
  const [state, setState] = useState({
    loading: false,
    dateValue: "",
    fName: "",
    lName: "",
    nationalCode: "",
    dateActive: false,
    errorValid: false,
  });

  const handleClick = () => {
    setIsOpen(true);
    setState({
      ...state,
      dateActive: true,
    });
  };

  useEffect(() => {
    if (document.getElementsByClassName("datepicker-modal")[0] !== undefined) {
      if (isOpen) {
        document
          .getElementsByClassName("datepicker-modal")[0]
          .classList.add("active");
      } else {
        document
          .getElementsByClassName("datepicker-modal")[0]
          .classList.remove("active");
      }
    }
  }, [isOpen]);

  const handleCancel = () => {
    setIsOpen(false);
    setState({
      ...state,
      dateActive: false,
    });
  };

  const handleSelect = (time) => {
    setIsOpen(false);
    setTime(time);
    setState({
      ...state,
      dateValue: time.jy + "/" + time.jm + "/" + time.jd,
      dateActive: false,
    });
    document
      .getElementById("datePicker-label")
      .classList.add("MuiInputLabel-shrink");
  };

  const dateConfigMap2 = {
    year: {
      format: "YYYY",
      caption: "سال",
      step: 1,
    },
    month: {
      format: "M",
      caption: "ماه",
      step: 1,
    },
    date: {
      format: "D",
      caption: "روز",
      step: 1,
    },
  };

  useEffect(() => {
    // console.log(jalaali.toJalaali(new Date()))
    const infoPerson = JSON.parse(localStorage.getItem("personalInfo"));
    setTimeout(() => {
      if (infoPerson !== null) {
        setState({
          ...state,
          loading: true,
          fName: infoPerson.firstName,
          lName: infoPerson.lastName,
          nationalCode: infoPerson.nationalCode,
          dateValue: infoPerson.dateBirthday,
        });
      } else {
        setState({
          ...state,
          loading: true,
        });
      }
      console.log(state);
    }, 300);
  }, []);

  const handleInputValue = (e, target) => {
    setState({
      ...state,
      [target]: e.target.value,
    });
  };

  const contniue = () => {
    const data = {
      firstName: state.fName,
      lastName: state.lName,
      nationalCode: state.nationalCode,
      dateBirthday: state.dateValue,
    };
    if (
      data.firstName.trim().length !== 0 &&
      data.lastName.trim().length !== 0 &&
      data.nationalCode.trim().length == 10 &&
      data.dateBirthday.trim().length !== 0
    ) {
      localStorage.setItem("personalInfo", JSON.stringify(data));
      props.history.push("/Entrance/step4");
    } else {
      setState({
        ...state,
        errorValid: true,
      });
    }
  };

  return (
    <div
      className={`entrnc-base pesronal-info ${state.loading ? "active" : ""}`}
    >
      <div className="titles-base titles-style-2">
        <h4>
          <Link to="/Entrance/step2">
            <i className="icon-arrow-down-sign-to-navigate"></i>
          </Link>
          اطلاعات شخصی
        </h4>
        <div className="step-progress">
          <span className="active"></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <div className="bx-info">
        <div className="input-form">
          <TextField
            id="standard-basic"
            label="نام *"
            value={state.fName}
            onChange={(e) => handleInputValue(e, "fName")}
          />
          <span
            className={`error-respns ${
              state.errorValid && state.fName.trim().length == 0 ? "active" : ""
            }`}
          >
            <i className="icon-exclamation-mark"></i>
            نام خود را کامل وارد کنید
          </span>
        </div>
        <div className="input-form">
          <TextField
            id="standard-basic"
            label="نام خانوادگی *"
            value={state.lName}
            onChange={(e) => handleInputValue(e, "lName")}
          />
          <span
            className={`error-respns ${
              state.errorValid && state.lName.trim().length == 0 ? "active" : ""
            }`}
          >
            <i className="icon-exclamation-mark"></i>
            نام خانوادگی خود را کامل وارد کنید
          </span>
        </div>
        <div className="input-form national-cd">
          <TextField
            id="standard-basic"
            label="کد ملی *"
            value={state.nationalCode}
            onChange={(e) => handleInputValue(e, "nationalCode")}
            onInput={(e) => {
              if (!/^\d+$/.test(e.target.value)) {
                e.target.value = "";
              }
              e.target.value = e.target.value.slice(0, 10);
            }}
          />
          <span
            className={`error-respns ${
              state.errorValid && state.nationalCode.trim().length !== 10
                ? "active"
                : ""
            }`}
          >
            <i className="icon-exclamation-mark"></i>
            کد ملی خود را کامل وارد کنید
          </span>
        </div>
        <div
          className={`input-form date ${state.dateActive ? "actived" : ""}`}
          onClick={handleClick}
        >
          <a className="select-btn">
            <i className="icon-calendar-1"></i>
          </a>
          <TextField
            value={state.dateValue}
            id="datePicker"
            label="تاریخ تولد *"
            onChange={(e) => handleInputValue(e, "dateValue")}
          />
          <span
            className={`error-respns ${
              state.errorValid && state.dateValue.trim().length == 0
                ? "active"
                : ""
            }`}
          >
            <i className="icon-exclamation-mark"></i>
            تاریخ تولد خود را کامل وارد کنید
          </span>
        </div>
        <div className="btn-base btn-black btn-sircle">
          <Button variant="contained" onClick={contniue}>
            ادامه
          </Button>
        </div>
        <DatePicker
          value={time}
          isOpen={isOpen}
          // max={jalaali.toJalaali(new Date(2000,1,1))}
          onSelect={handleSelect}
          onCancel={handleCancel}
          dateConfig={dateConfigMap2}
          confirmText="تایید"
          customHeader="تاریخ تولد"
          cancelText="لغو"
        />
      </div>
    </div>
  );
};

export default Personalinfo;
